import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  isLoading$ = this.loadingService.loading$;
  message$ = this.loadingService.message$;

  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
  }
}
